<template>
  <div class="flex flex-col gap-8" data-cy="contract-signed-page">
    <div class="flex flex-col items-center gap-1 text-center">
      <AtomText
        :text="t('subscription.contractSigned.title')"
        font-size="text-xl"
        font-style="font-semibold"
        data-cy="contract-signed-page-title"
      />
      <p class="text-center" data-cy="contract-signed-page-subtitle">
        <AtomText
          is-tag="span"
          font-size="text-base"
          color-variant="description"
          :text="subtitleParts[0]"
        /><AtomText
          is-tag="span"
          font-size="text-base"
          font-style="font-semibold"
          color-variant="description"
          :text="subtitleParts[1]"
        /><AtomText
          is-tag="span"
          font-size="text-base"
          color-variant="description"
          :text="subtitleParts[2]"
        />
      </p>
    </div>

    <ActivateAccountCard :email="contractorEmail" />

    <NextStepsSection />

    <div>
      <AtomDivider class="mb-8" />
      <AppDownloadSection />
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useSubscriptionStore } from '@/stores';

import ActivateAccountCard from '@/components/subscription/ContractSigned/ActivateAccountCard.component.vue';
import AppDownloadSection from '@/components/subscription/ContractSigned/AppDownloadSection.component.vue';
import NextStepsSection from '@/components/subscription/ContractSigned/NextStepsSection.component.vue';

const { t, tm } = useI18n();

const subscriptionStore = useSubscriptionStore();
const { currentSubscription } = storeToRefs(subscriptionStore);

const subtitleParts = computed(() => tm('subscription.contractSigned.subtitle'));

const contractorEmail = computed(
  () =>
    currentSubscription.value?.companyContractor?.contact?.email ??
    currentSubscription.value?.individualContractor?.contractor?.email ??
    ''
);
</script>

<style scoped></style>
